type GroupBy<T> = {
  [key: string]: T[];
};

export function groupBy<T>(array: T[], keys: (keyof T)[]): GroupBy<T> {
  return array.reduce((result, item) => {
    // Create a composite key by joining each field's value
    const groupKey = keys.map(key => String(item[key])).join('_');
    if (!result[groupKey]) {
      result[groupKey] = [];
    }
    result[groupKey].push(item);
    return result;
  }, {} as GroupBy<T>);
}